import React, { createContext, useContext, useState, useCallback, useMemo } from "react";
import { toast } from "sonner";
import { useUserAuth } from "./UserAuthContext";

const CartContext = createContext(null);

export const CartProvider = ({ children }) => {
  const { user } = useUserAuth();
  const [items, setItems] = useState([]);
  const [open, setOpen] = useState(false);
  const [gateOpen, setGateOpen] = useState(false);

  const isCardHolder = !!user && !!user.has_card && user.card_status !== "rejected";

  const addItem = useCallback((product) => {
    if (!isCardHolder) {
      setGateOpen(true);
      return false;
    }
    setItems((prev) => {
      const existing = prev.find((i) => i.product_id === product.id);
      if (existing) {
        return prev.map((i) =>
          i.product_id === product.id ? { ...i, quantity: i.quantity + 1 } : i
        );
      }
      return [
        ...prev,
        {
          product_id: product.id,
          title: product.title,
          price: product.price,
          image: product.image,
          quantity: 1,
        },
      ];
    });
    toast.success(`${product.title} aggiunto al carrello`);
    return true;
  }, [isCardHolder]);

  const removeItem = useCallback((productId) => {
    setItems((prev) => prev.filter((i) => i.product_id !== productId));
  }, []);

  const updateQty = useCallback((productId, qty) => {
    if (qty <= 0) {
      setItems((prev) => prev.filter((i) => i.product_id !== productId));
      return;
    }
    setItems((prev) =>
      prev.map((i) => (i.product_id === productId ? { ...i, quantity: qty } : i))
    );
  }, []);

  const clearCart = useCallback(() => setItems([]), []);

  const total = useMemo(
    () => items.reduce((sum, i) => sum + i.price * i.quantity, 0),
    [items]
  );
  const count = useMemo(
    () => items.reduce((sum, i) => sum + i.quantity, 0),
    [items]
  );

  return (
    <CartContext.Provider
      value={{
        items, addItem, removeItem, updateQty, clearCart, total, count,
        open, setOpen,
        gateOpen, setGateOpen,
        isCardHolder,
      }}
    >
      {children}
    </CartContext.Provider>
  );
};

export const useCart = () => {
  const ctx = useContext(CartContext);
  if (!ctx) throw new Error("useCart must be used inside CartProvider");
  return ctx;
};
